import axios from 'axios';
import { getToken } from 'utils/crypto';

const BASE = '/ai/assistant/sessions';

export const aiAssistantService = {
    openSession: () => axios.post(BASE, {}, { auth: true }),

    /** Sends only the new message — the server holds the history. */
    sendMessage: (sessionId, body) => axios.post(`${BASE}/${sessionId}/messages`, body, { auth: true }),

    /** `{ dailyRemainingPercent }` — how much of today's assistant use is left (tightest daily spend cap); `null` when none applies. */
    getQuota: () => axios.get('/ai/assistant/quota', { auth: true }),

    closeSession: (sessionId) => axios.delete(`${BASE}/${sessionId}`, { auth: true }),

    /**
     * Fire-and-forget close that survives the tab closing. `keepalive` lets the
     * request outlive the page; axios cannot do that.
     */
    closeSessionOnUnload: (sessionId) => {
        const token = getToken();
        if (!token) return;
        fetch(`${process.env.REACT_APP_API_BASE}${BASE}/${sessionId}`, {
            method: 'DELETE',
            keepalive: true,
            headers: { 'access-token': token },
        }).catch(() => {});
    },
};
